module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesUrban.86b487a.jpg";